"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _MarketDataCardsComponent = _interopRequireDefault(require("./MarketDataCardsComponent"));
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var level1 = state.apexCore.level1;
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var products = (0, _productPositionSelectors.productPositionAssetsSelector)(state);
  return {
    level1: level1,
    instruments: instruments,
    products: products
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_MarketDataCardsComponent["default"]);